import { NeoModel, Attributes, ModelBase, Misc } from '@singularsystems/neo-core';
import { TimeSpan } from '@singularsystems/neo-core/dist/Dates/TimeSpan';
@NeoModel
export default class RawGenericTransactionLookup extends ModelBase {
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public eventDate: Date | null = null;

    public eventTime: TimeSpan | null = null;

    public clientNumber: string = "";

    public stockbrokerAccount: string = "";

    public eventName: string = "";

    public buyOrSell: string = "";

    public eventID: string = "";

    public relatedEventID: string = "";

    public instrumentDescription: string = "";

    public ticker: string = "";

    public isin: string = "";

    public staticInstrumentID: number | null = null;

    public staticEventID: number | null = null;

    public currency: string = "";

    public marketPrice: number | null = null;

    public unitPrice: number | null = null;

    public quantity: number | null = null;

    public amount: number | null = null;

    public amountUSD: number | null = null;

    public isExcludedInd: boolean = false;

    public isReversalInd: boolean = false;

    public rawGenericSecurityTransactionID: number = 0;

    public rawGenericCashTransactionID: number = 0;

    public selected: boolean = false;

    public rawEventType: string = "";

    public rawCorporateActionType: string = "";

    public rawEventID: string = "";
}